/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const listContactsQueryParamsSchema = z.object({
    "pageSize": z.optional(z.any().describe("Items per page (default 25, max 100)")),
"page": z.optional(z.any().describe("Page number (default 1)"))
    }).optional()

export const listContactsHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Contact owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Contacts page
 */
export const listContacts200Schema = z.object({
    "items": z.array(z.object({
    "id": z.string(),
"userId": z.string(),
"externalId": z.nullable(z.string()),
"name": z.nullable(z.string()),
"title": z.nullable(z.string()),
"email": z.nullable(z.string()),
"phone": z.nullable(z.string()),
"company": z.nullable(z.string()),
"location": z.nullable(z.string()),
"socialMedia": z.nullable(z.object({
    
    }).catchall(z.string())),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    })),
"total": z.int().min(-9007199254740991).max(9007199254740991),
"page": z.int().min(-9007199254740991).max(9007199254740991),
"pageSize": z.int().min(-9007199254740991).max(9007199254740991)
    })

/**
 * @description Invalid page/pageSize
 */
export const listContacts400Schema = z.any()

export const listContactsQueryResponseSchema = z.lazy(() => listContacts200Schema)